import React, { useState } from "react";
import styles from "./DelayMemory.module.css";
import { updateScore } from "../../utils/storage";

const DelayMemory = ({ goHome }) => {
  const [sequence, setSequence] = useState([]);
  const [input, setInput] = useState("");

  const [phase, setPhase] = useState("idle"); 
  // idle | show | delay | input | result

  const [level, setLevel] = useState(1);
  const [score, setScore] = useState(0);
  const [delayTime, setDelayTime] = useState(3);

  const [countdown, setCountdown] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [gameOver, setGameOver] = useState(false);

  // 🔥 sequência cresce rápido
  const generateSequence = () => {
    const size = Math.min(12, Math.floor(3 + level * 0.8));
    const arr = [];

    for (let i = 0; i < size; i++) {
      arr.push(Math.floor(Math.random() * 9) + 1);
    }

    return arr;
  };

  const start = () => {
    const seq = generateSequence();

    setSequence(seq);
    setPhase("show");
    setInput("");
    setFeedback("");

    // tempo mostrando
    setTimeout(() => {
      startDelay();
    }, 2000);
  };

  const startDelay = () => {
    let time = Math.min(10, 2 + Math.floor(level * 0.7)); // 🔥 delay cresce

    setCountdown(time);
    setPhase("delay");

    const interval = setInterval(() => {
      time--;

      setCountdown(time);

      if (time <= 0) {
        clearInterval(interval);
        setPhase("input");
      }
    }, 1000);
  };

  const check = () => {
    const correct = input === sequence.join("");

    if (correct) {
      const newScore = score + level * 22;

      setScore(newScore);
      setLevel(level + 1);
      setFeedback("🧠 Excelente retenção!");

      updateScore("delay", newScore);

      setTimeout(() => {
        start();
      }, 800);
    } else {
      setFeedback("❌ Você esqueceu parte da sequência.");
      setGameOver(true);
    }
  };

  const restart = () => {
    setSequence([]);
    setInput("");
    setPhase("idle");
    setLevel(1);
    setScore(0);
    setGameOver(false);
    setFeedback("");
  };

  if (gameOver) {
    return (
      <div className={styles.container}>
        <h3>⏱️ Memória de Retenção</h3>

        <p>Nível: {level}</p>
        <p>Pontuação: {score}</p>

        <button className={styles.button} onClick={restart}>
          Jogar Novamente
        </button>

        <button className={styles.buttonSecondary} onClick={goHome}>
          Voltar
        </button>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h3>⏱️ Memória de Retenção</h3>
      <div className={styles.info}>
        <span>Nível: {level}</span>
        <span>Pontos: {score}</span>
      </div>

      {/* FASE: MOSTRAR */}
      {phase === "show" && (
        <div className={styles.sequenceBox}>
          {sequence.join(" ")}
        </div>
      )}

      {/* FASE: DELAY */}
      {phase === "delay" && (
        <div className={styles.delayBox}>
          <p>⏳ Aguarde...</p>
          <span>{countdown}s</span>
        </div>
      )}

      {/* FASE: INPUT */}
      {phase === "input" && (
        <div className={styles.inputBox}>
          <input
            className={styles.input}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Digite a sequência..."
          />

          <button className={styles.button} onClick={check}>
            Confirmar
          </button>
        </div>
      )}

      {/* INICIO */}
      {phase === "idle" && (
        <button className={styles.button} onClick={start}>
          Iniciar Teste
        </button>
      )}

      <p className={styles.feedback}>{feedback}</p>

      <button className={styles.buttonSecondary} onClick={goHome}>
        Voltar
      </button>
    </div>
  );
};

export default DelayMemory;